var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 126,
    viewBox: "0 0 207 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.85 25.56C110.77 25.56 116.38 19.9501 116.38 13.03C116.38 6.10987 110.77 0.5 103.85 0.5C96.9297 0.5 91.3198 6.10987 91.3198 13.03C91.3198 19.9501 96.9297 25.56 103.85 25.56Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8198 60.23H128.28C129.81 60.17 128.99 58.13 128.84 57.05C125.29 31.06 102.84 33.01 102.84 33.01C81.6898 34.66 78.3698 51.89 77.8598 58.12C77.7598 59.36 79.0898 60.3 80.8198 60.23Z",
    fill: "#FFD148",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0202 46.9699C71.9404 46.9699 77.5502 41.36 77.5502 34.4399C77.5502 27.5198 71.9404 21.9099 65.0202 21.9099C58.1001 21.9099 52.4902 27.5198 52.4902 34.4399C52.4902 41.36 58.1001 46.9699 65.0202 46.9699Z",
    fill: "#8ED943",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9902 81.6399H89.4502C90.9802 81.5799 90.1602 79.5399 90.0102 78.4599C86.4602 52.4699 64.0102 54.4199 64.0102 54.4199C42.8602 56.0699 39.5402 73.2999 39.0302 79.5299C38.9302 80.7699 40.2602 81.7099 41.9902 81.6399Z",
    fill: "#8ED943",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.51 46.9699C147.43 46.9699 153.04 41.36 153.04 34.4399C153.04 27.5198 147.43 21.9099 140.51 21.9099C133.59 21.9099 127.98 27.5198 127.98 34.4399C127.98 41.36 133.59 46.9699 140.51 46.9699Z",
    fill: "#8ED943",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.47 81.6399H164.93C166.46 81.5799 165.64 79.5399 165.49 78.4599C161.94 52.4699 139.49 54.4199 139.49 54.4199C118.34 56.0699 115.02 73.2999 114.51 79.5299C114.41 80.7699 115.74 81.7099 117.47 81.6399Z",
    fill: "#8ED943",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5002 72.6899C33.4203 72.6899 39.0302 67.08 39.0302 60.1599C39.0302 53.2398 33.4203 47.6299 26.5002 47.6299C19.5801 47.6299 13.9702 53.2398 13.9702 60.1599C13.9702 67.08 19.5801 72.6899 26.5002 72.6899Z",
    fill: "#04BF8A",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46017 107.36H50.9202C52.4502 107.3 51.6302 105.26 51.4802 104.18C47.9302 78.1899 25.4802 80.1399 25.4802 80.1399C4.34017 81.7999 1.01017 99.0199 0.510172 105.26C0.410172 106.5 1.74017 107.44 3.47017 107.37L3.46017 107.36Z",
    fill: "#04BF8A",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.53 72.6899C110.45 72.6899 116.06 67.08 116.06 60.1599C116.06 53.2398 110.45 47.6299 103.53 47.6299C96.6099 47.6299 91 53.2398 91 60.1599C91 67.08 96.6099 72.6899 103.53 72.6899Z",
    fill: "#04BF8A",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4902 107.36H127.95C129.48 107.3 128.66 105.26 128.51 104.18C124.96 78.1899 102.51 80.1399 102.51 80.1399C81.3602 81.7899 78.0402 99.0199 77.5302 105.25C77.4302 106.49 78.7602 107.43 80.4902 107.36Z",
    fill: "#04BF8A",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.56 72.6899C187.48 72.6899 193.09 67.08 193.09 60.1599C193.09 53.2398 187.48 47.6299 180.56 47.6299C173.64 47.6299 168.03 53.2398 168.03 60.1599C168.03 67.08 173.64 72.6899 180.56 72.6899Z",
    fill: "#04BF8A",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.52 107.36H204.98C206.51 107.3 205.69 105.26 205.54 104.18C201.99 78.1899 179.54 80.1399 179.54 80.1399C158.39 81.7899 155.07 99.0199 154.56 105.25C154.46 106.49 155.79 107.43 157.52 107.36Z",
    fill: "#04BF8A",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0202 90.03C71.9404 90.03 77.5502 84.4201 77.5502 77.5C77.5502 70.5798 71.9404 64.97 65.0202 64.97C58.1001 64.97 52.4902 70.5798 52.4902 77.5C52.4902 84.4201 58.1001 90.03 65.0202 90.03Z",
    fill: "#038C7F",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9902 124.71H89.4502C90.9802 124.65 90.1602 122.61 90.0102 121.53C86.4602 95.54 64.0102 97.49 64.0102 97.49C42.8602 99.14 39.5402 116.37 39.0302 122.6C38.9302 123.84 40.2602 124.78 41.9902 124.71Z",
    fill: "#038C7F",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.03 90.52C148.95 90.52 154.56 84.9101 154.56 77.99C154.56 71.0698 148.95 65.46 142.03 65.46C135.11 65.46 129.5 71.0698 129.5 77.99C129.5 84.9101 135.11 90.52 142.03 90.52Z",
    fill: "#038C7F",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 125.2H166.46C167.99 125.14 167.17 123.1 167.02 122.02C163.47 96.03 141.02 97.98 141.02 97.98C119.87 99.63 116.55 116.86 116.04 123.09C115.94 124.33 117.27 125.27 119 125.2Z",
    fill: "#038C7F",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206.4,
    height: 125.71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.41fa49d3e3a4b20e92a6056f70f69944.svg";
export { ForwardRef as ReactComponent };